import React, { useEffect, useState } from 'react';
import RatingSelector from './RatingSelector';
import { TextareaAutosize } from '@mui/material';
import ReviewImageUploader from './ReviewImageUploader';
import './../pages/Anonymous/Adjuster/style.css';
import getImageURL from '../_helpers/getImageURL';

const RatingForm = ({ defaultData, isLoading, infosetting, onReviewSubmit }) => {
    const [ratingValue, setRatingValue] = useState(4);
    const [reviewText, setReviewText] = useState("");
    const [images, setImages] = useState([]);


    useEffect(() => {
        if (defaultData) {
            setRatingValue(defaultData.rating);
            setReviewText(defaultData.review);
            if (defaultData.images && defaultData.images.length > 0) {
                setImages(defaultData.images.map((img, i) => {
                    return {
                        file: { name: i + 1 },
                        preview: getImageURL(img.path),
                        id: Date.now() + Math.random().toString(36).substring(2, 15)
                    }
                }))
            }
        }
    }, [defaultData]);

    const onSubmit = (e) => {
        e.preventDefault();
        onReviewSubmit(ratingValue, reviewText, images, defaultData ? true : false);
    }

    return (
        <div className='ap-rating-form-content'>
            {!defaultData && <h3>Rate this Adjuster</h3>}
            <RatingSelector value={ratingValue} onChange={setRatingValue} />
            <hr className='hr2 mt-20'></hr>
            <form className='ap-rating-review-container' onSubmit={onSubmit}>
                <p className='primary-text mt-20'>{defaultData ? `Review *` : `Write a Review *`}</p>
                <span className='ap-rating-caption'>Discuss the insurance adjuster's professional abilities including assessment style and ability to convey the claim details clearly.</span>
                <div className='ap-rating-guide-container mt-20'>
                    <div className='row'>
                        <i class="fa-solid fa-triangle-exclamation"></i>
                        <span className='primary-text ml-10'>Guidelines</span>
                    </div>
                    <ul className='ap-guide-bullets'>
                        <li>Your rating could be removed if you use profanity or derogatory terms.</li>
                        <li>Don't claim that the insurance adjuster shows bias or favoritism for or against clients.</li>
                    </ul>
                </div>
                <TextareaAutosize className='ap-rating-review mt-20' defaultValue={defaultData ? reviewText : undefined} onChange={({ target }) => setReviewText(target.value)} minRows={8} placeholder="What do you want other clients to know about this insurance adjuster?" />

                <ReviewImageUploader onImagesChange={setImages} defaultImages={defaultData && defaultData.images && defaultData.images.length > 0 && images.length > 0 ? images : undefined} />

                <div className='column center'>
                    <p className='form-agreement text-center ap-terms'>By clicking the "Submit" button, I acknowledge that I have read and agreed to the {infosetting.title} Site Guidelines, Terms of Use and Privacy Policy. Submitted data becomes the property of {infosetting.title}.</p>
                    <button type="submit" class="btn btn-block btn-sm mt-5" disabled={isLoading}>
                        {isLoading ? "Please Wait..." : "Submit Rating"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default RatingForm;